import { loan_request } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export type ISearchLoanRequest =
  | { loanApplicationID: string }
  | { lenderID: string };

export function get({ url: { service: baseURL }, token }: IAPI) {
  return async function get(
    loanRequestID: string
  ): Promise<loan_request.LoanRequest> {
    const url = new URL(`/loan-quote/request/${loanRequestID}`, baseURL);

    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const responseJson = await response.json();

    if (response.ok) return responseJson;

    throw new Error(
      `Error fetching ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.message}`
    );
  };
}

// For now we only need to patch the status in the case of cancellation. The fields available for patching should be extended as needed.
export type IPatchLoanRequest = Partial<
  Pick<loan_request.LoanRequest, 'Status'>
>;

export function patch({ url: { service: baseURL }, token }: IAPI) {
  return async function patch(
    loanRequestID: string,
    input: IPatchLoanRequest
  ): Promise<loan_request.LoanRequest> {
    const url = new URL(`/loan-quote/request/${loanRequestID}`, baseURL);

    const response = await fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(input),
    });

    const responseJson = await response.json();

    if (response.ok) return responseJson;

    throw new Error(
      `Error patching ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.message}`
    );
  };
}

export function find({ url: { service: baseURL }, token }: IAPI) {
  return async function find(
    search: ISearchLoanRequest
  ): Promise<loan_request.LoanRequest[]> {
    const url = new URL('/loan-quote/request', baseURL);
    const parameters = Object.entries(search);
    parameters.forEach((parameter) =>
      url.searchParams.append(parameter[0], parameter[1])
    );

    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const responseJson = await response.json();

    if (response.ok) return responseJson;

    throw new Error(
      `Error fetching ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.message}`
    );
  };
}
